import React from 'react';
import PageContainer from 'components/layout/PageContainer';
import { TITLES } from 'constants/pagesTitles';
import TutorialsPage from '../../core/views/TutorialsPage';

const Tutorials = () => (
  <PageContainer title={TITLES.tutorials} isImgBg>
    <TutorialsPage />
  </PageContainer>
);

export default Tutorials;
